var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage build-a-keyboard"
  }, [_c('div', {
    attrs: {
      "id": "dragging-content"
    }
  }, [_c('keyboard-k2-lite'), _vm.currentStep ? _c('div', {
    staticClass: "draggable-key-container",
    class: {
      scatter: _vm.currentStep.scattered
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }